import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../CoreWrappers/Button';

const ToolbarButton = ({svg = null, label = null, onClick = null, ...rest}) => {
	const props = {
		...rest,
		type: 'button',
		variant: 'ghost',
		iconSize: 20
	};

	if (onClick) props.onClick = onClick;
	if (svg) props.svg = svg;
	if (label) {
		props.label = label;
		props.title = label;
	}

	return <Button {...props} />;
};

ToolbarButton.propTypes = {
	label: PropTypes.string,
	onClick: PropTypes.func
};

export default ToolbarButton;
